import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function ParkingLocations() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">
          {t("parkingLocations")}
        </h1>
        <p className="text-muted-foreground">
          Manage saved parking locations for automatic parking detection
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Saved Locations</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Parking locations management will be implemented here.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
